import React, { useEffect, useRef, useState, useContext } from "react";
import CheckoutForm from "./Checkoutform";
import styled from "styled-components";
import Modal from "react-modal";

import {UserContext} from '../../utils/userDetailsProvider';

import { Bars } from "react-loader-spinner";

import {sendBidToBackend} from '../../utils/backendUtils';
import eventBus from '../../utils/globalPubSub';

import SuccessBidComponent from './SuccessBidComponent'
import Web2IndiaBidComponent from './Web2IndiaBidComponent';

import CancelIcon from "../../assets/cancel_icon.svg";
import { PaymentContext } from "../../utils/paymentConfigProvider";

var Filter = require('bad-words'),
    filter = new Filter();

const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const InputContainerDiv = styled.div`
  width: '100%';
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`

const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, .4);
  }
`

const DollarSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #FFFFFF;
  opacity: 0.45;
`

const CurrentTopBidDiv = styled.div`
  display: flex;
  margin-top: 16px;
`

const InformationSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`

const ButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;   
`

const PlaceBidButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: #FFFFFF;
  margin-top: 24px;
  cursor: pointer;
`

const GlipHelpTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.7;
  display: block;
`

const ErrorSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FF5A5A;
`


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function Web2BidComponents(props) {
    const [inputText, setInputText] = useState('');
    const [bidderMessage, setBidderMessage] = useState('');    
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [success, setSuccess] = useState(false);
    
    const userDetails = useContext(UserContext);
    const paymentConfig = useContext(PaymentContext);

    let isIndiaPayment = false;
    
    if(paymentConfig && paymentConfig.acceptedGateways){
        isIndiaPayment = ((paymentConfig.acceptedGateways.includes(
            'razorpay'))? true: false);
    }
    
    useEffect(()=>{
        setInputText('');
        setBidderMessage('');
        setError('');
        setSuccess(false);
        setLoader(false);
    },[props.isOpen])
    
    const handleInputText = (value) => {
        let adjustedValue = (value.indexOf(".") >= 0) ? (value.substr(0, value.indexOf(".")) + value.substr(value.indexOf("."), 3)) : value;
        setInputText(adjustedValue);        
    }
    
    const sendBid = async (val, dirtyMessage) => {
        let cleanedMessage = filter.clean(dirtyMessage);
        setLoader(true);
        let resp = await sendBidToBackend(
            val, props.item.auctionId,
            props.item._id,
            cleanedMessage
        );
        setLoader(false);
        if(!resp){
            setError('Failed')
            setTimeout(()=>{setError('')}, 5000);
            return
        }
        if(!resp.success){
            setError(resp.message);
            setTimeout(()=>{setError('')}, 5000);
            return;
        }
        if(resp.success){
            eventBus.dispatch("new-bid-add");
            setSuccess(true);
        }
    }

    const handleModalCloseEvent = () =>{
        props.closeModal()
    }
    
    let modalWidth = "446px";
    let modalHeight = "400px";
    if(userDetails.isMobile){
        modalWidth = '341px';
        modalHeight = '350px'
    }
    
    return (
        <>
            {(isIndiaPayment) && (
                <>
                    <Web2IndiaBidComponent
                        isOpen={props.isOpen}
                        closeModal={props.closeModal}
                        item={props.item}
                        topBid={props.topBid}
                        topBidUser={props.topBidUser}
                    >
                    </Web2IndiaBidComponent>
                </>
            )}
            {(!isIndiaPayment) && (
                <Modal
	            isOpen={props.isOpen}
	            style={{
	                content: {
		            background: "#0F0F0F",
		            width: modalWidth,
		            height: modalHeight,
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
		            border:"none",
                    }}}>
                    <div style={{marginLeft:24, marginTop:30,
		                 marginRight:24, marginBottom:30,
		                 position: "relative"
	            }}>
                        <img onClick={()=>{handleModalCloseEvent();}}
	                     src={CancelIcon}
	                     style={{
	                         position: "absolute", opacity: 0.4,
	                         height: 14, width:14,
	                         right:10, cursor:"pointer",
	                         zIndex:10}}
	                />
                        {!success && (
                            <>
	                        <HeaderSpan>
		                    BID (USD)
	                        </HeaderSpan>
	                        <InputContainerDiv style={{marginTop: 24}}>
                                    <span style={{marginLeft:10}}>$
                                    </span>
		                    <StyledInput
		                        placeholder={"Enter amount"}
		                        value={inputText}
		                        type="number"
		                        onChange={e =>handleInputText(e.target.value)}
		                    />
	                        </InputContainerDiv>
                                <InputContainerDiv style={{marginTop: 24}}>
		                    <StyledInput
                                        maxLength="15"
		                        placeholder={
                                        "Send message to live stream"}
		                        value={bidderMessage}
		                        onChange={e =>{
                                            setBidderMessage(
                                                e.target.value)}}
                                    
		                    />
	                        </InputContainerDiv>
                                
                                {error && (
		                    <ErrorSpan style={{marginTop: 16}}>
		                        {error}
		                    </ErrorSpan>
	                        )}
                                {/*
	                            <CurrentTopBidDiv>
		                    <InformationSpan>
		                    Current top bid: 83 MATIC / $20
		                    </InformationSpan>
	                            </CurrentTopBidDiv>
                                  */}
	                        <PlaceBidButtonDiv onClick={()=>{
                                    if(loader){
                                        return;
                                    }
                                    sendBid(inputText, bidderMessage)}}>
                                    {(!loader) && (
                                        <ButtonTextSpan>
	                                    PLACE BID
	                                </ButtonTextSpan>
                                    )}
                                    {(loader) && (
                                        <Bars
                                            heigth="30" width="30"
                                            color="grey"
                                            ariaLabel="loading-indicator" />
                                    )}
	                        </PlaceBidButtonDiv>
	                        <GlipHelpTextSpan style={{marginTop:18}}>
		                    Money will be deducted from your card
                                    only if you win the auction.
	                        </GlipHelpTextSpan>

                            </>
                        )}
                        {success && (
                            <SuccessBidComponent
                                handleModalCloseEvent={handleModalCloseEvent}>
                            </SuccessBidComponent>
                        )}
                    </div>
                </Modal>
            )}
        </>

        
    );
}
